export const en = {
    collapse: 'Collapse',
    expand: 'Expand',
    more: '{count} more',
};
